var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlane = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.064,
  d: "M19.08 9.736H5.033l-.706-2.14a.92.92 0 0 0-.87-.628H1.368l.788 4.76a.926.926 0 0 0 .906.776h6.549l-1.832 8.303h2.748l4.579-8.303H21.8a.64.64 0 0 0 .449-1.098l-.577-.582a3.65 3.65 0 0 0-2.592-1.08z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.064,
  d: "M9.611 9.736 7.779 1.432h2.207c.33 0 .642.185.797.47l4.314 7.834H9.602z"
})));
export default SvgPlane;